/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { ReactElement, useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import DropdownList from './dropdownList';

interface IDropdownItemProps {
  data: any[];
  selectedItemName: string;
  handleSelectItem: (index: number) => void;
}

const DropdownItem = ({
  data,
  selectedItemName,
  handleSelectItem
}: IDropdownItemProps): ReactElement => {
  const [dropdownState, setDropdownState] = useState<{ isListOpen: boolean }>({
    isListOpen: false
  });

  const { isListOpen } = dropdownState;

  const toggleDropdownState = () => {
    setDropdownState({
      isListOpen: !isListOpen
    });
  };
  return (
    <OutsideClickHandler onOutsideClick={() => setDropdownState({ isListOpen: false })}>
      <div className="dropdown-wrapper" onClick={toggleDropdownState}>
        <button className="dropdown-header" type="button">
          <div className="dropdown-header-title">{selectedItemName}</div>
          <i className="material-icons arrow-icon">{isListOpen ? 'expand_less' : 'expand_more'}</i>
        </button>
        {isListOpen && (
          <div className="dropdown-list">
            {data.map((item, index) => {
              return (
                <DropdownList
                  key={`${item}${index}`}
                  name={item}
                  index={index}
                  selectItem={handleSelectItem}
                />
              );
            })}
          </div>
        )}
      </div>
    </OutsideClickHandler>
  );
};

export default DropdownItem;
